import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.313 6.5h11.375c.71 0 1.312.602 1.312 1.313 0 .437-.219.82-.547 1.066l-5.933 4.457a.86.86 0 0 1-1.067 0L5.52 8.879A1.31 1.31 0 0 1 5 7.813C5 7.102 5.574 6.5 6.313 6.5M5 9.563l5.934 4.484a1.76 1.76 0 0 0 2.105 0L19 9.562v5.688c0 .984-.793 1.75-1.75 1.75H6.75C5.766 17 5 16.234 5 15.25z"
    }, null, -1)
  ]))]))
}
export default { render: render }